// <-- Icon Imports -->
import { Loader } from "lucide-react";

const Loading: React.FunctionComponent = () => {
  return (
    <div className="flex h-screen items-center justify-center align-middle">
      <Loader className="animate-spin text-primary" width={40} height={40} />
    </div>
  );
};

export { Loading };
